'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _Immutable = require('Immutable');

var _ActivityType = require('MeetingsBase/models/ActivityType');

var _ActivityType2 = _interopRequireDefault(_ActivityType);

var _Availability = require('MeetingsBase/models/Availability');

var _Availability2 = _interopRequireDefault(_Availability);

var _DisplayInfo = require('MeetingsBase/models/DisplayInfo');

var _DisplayInfo2 = _interopRequireDefault(_DisplayInfo);

var _FormField = require('MeetingsBase/models/FormField');

var _FormField2 = _interopRequireDefault(_FormField);

var _LegalConsentOptions = require('MeetingsBase/models/LegalConsentOptions');

var _LegalConsentOptions2 = _interopRequireDefault(_LegalConsentOptions);

var _Reminder = require('MeetingsBase/models/Reminder');

var _Reminder2 = _interopRequireDefault(_Reminder);

var _enums = require('MeetingsBase/constants/enums');

var _dates = require('MeetingsBase/constants/dates');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaults = {
  // Alphabetical order
  activityType: null,
  availability: new _Availability2.default(),
  customAvailabilityStartDate: null,
  customAvailabilityEndDate: null,
  description: null,
  displayInfo: new _DisplayInfo2.default(),
  durations: new _Immutable.List([_dates.ZERO_DURATION]),
  formFields: (0, _Immutable.List)(),
  includeDescriptionInReminder: false,
  language: null,
  legalConsentEnabled: false,
  legalConsentOptions: null,
  locale: null,
  location: null,
  meetingBufferTime: _I18n2.default.moment.duration('00:15:00').asMilliseconds(),
  ownerPrioritized: false,
  minimumNoticeTime: _I18n2.default.moment.duration('00:15:00').asMilliseconds(),
  reminders: (0, _Immutable.List)(),
  sendReminder: false,
  subject: null,
  timezone: 'Europe/Dublin',
  videoConferenceExtensionAppId: null,
  weeksToAdvertise: 2
};

var getVisibleFormOptions = function getVisibleFormOptions(formFields) {
  return formFields.map(function (field) {
    if (_enums.FORM_FIELDS_WITH_OPTIONS.indexOf(field.type) > -1) {
      var visibleOptions = field.options.filter(function (option) {
        return !option.hidden && !option.readOnly;
      });
      field.options = visibleOptions;
    }
    return field;
  });
};

var LinkCustomParams = function (_Record) {
  _inherits(LinkCustomParams, _Record);

  function LinkCustomParams() {
    _classCallCheck(this, LinkCustomParams);

    return _possibleConstructorReturn(this, (LinkCustomParams.__proto__ || Object.getPrototypeOf(LinkCustomParams)).apply(this, arguments));
  }

  _createClass(LinkCustomParams, [{
    key: 'convertToJSON',
    value: function convertToJSON() {
      var json = this.update('legalConsentOptions', function (legalConsentOptions) {
        return legalConsentOptions ? legalConsentOptions.convertToJSON() : null;
      }).toJS();
      json.pushBackTime = this.minimumNoticeTime;
      delete json.minimumNoticeTime;
      return json;
    }
  }], [{
    key: 'from',
    value: function from(json) {
      if (json.timezone) {
        json.timezone = _I18n2.default.moment.tz.names().includes(json.timezone) ? json.timezone : 'Europe/Dublin';
      }

      var activityType = json.activityType && json.activityType !== '' ? _ActivityType2.default.from(json.activityType) : null;

      var legalConsentOptions = json.legalConsentOptions !== null ? _LegalConsentOptions2.default.from(json.legalConsentOptions) : null;

      return new LinkCustomParams({
        activityType: activityType,
        availability: _Availability2.default.from(json.availability),
        customAvailabilityStartDate: json.customAvailabilityStartDate,
        customAvailabilityEndDate: json.customAvailabilityEndDate,
        description: json.description,
        displayInfo: _DisplayInfo2.default.from(json.displayInfo),
        durations: (0, _Immutable.List)(json.durations),
        formFields: (0, _Immutable.List)(getVisibleFormOptions(json.formFields).map(function (field) {
          return _FormField2.default.from(field);
        })),
        includeDescriptionInReminder: json.includeDescriptionInReminder,
        language: json.language,
        legalConsentEnabled: json.legalConsentEnabled,
        legalConsentOptions: legalConsentOptions,
        locale: json.locale,
        location: json.location,
        meetingBufferTime: json.meetingBufferTime,
        ownerPrioritized: json.ownerPrioritized || false,
        minimumNoticeTime: json.pushBackTime,
        reminders: (0, _Immutable.List)(json.reminders.map(function (reminder) {
          return new _Reminder2.default(reminder);
        })),
        sendReminder: json.sendReminder,
        subject: json.subject,
        timezone: json.timezone,
        videoConferenceExtensionAppId: json.videoConferenceExtensionAppId,
        weeksToAdvertise: json.weeksToAdvertise
      });
    }
  }]);

  return LinkCustomParams;
}((0, _Immutable.Record)(defaults));

exports.default = LinkCustomParams;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsBase/target/src/MeetingsBase/static-1.2449/js/models/LinkCustomParams.js
// module id = 325
// module chunks = 0